import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Clock, ArrowRight, MessageSquare } from 'lucide-react';

export default function Testimonials() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-white pt-24" data-testid="testimonials-page">
      {/* Hero Section */}
      <section className="py-16 md:py-24 bg-[#ECFDF5]">
        <div className="max-w-7xl mx-auto px-6 md:px-12">
          <div className="max-w-3xl mx-auto text-center">
            <span className="text-[#10B981] text-sm font-semibold uppercase tracking-wider mb-4 block">Témoignages</span>
            <h1 className="text-4xl md:text-5xl font-bold text-[#1A1A1A] leading-tight mb-6" data-testid="testimonials-title">
              Ce que nos <span className="text-[#10B981]">partenaires</span> disent de l'expérience <span className="text-[#10B981]">0to1</span>
            </h1>
            <p className="text-lg text-[#1E3A5F] font-semibold leading-relaxed">
            </p>
          </div>
        </div>
      </section>

      {/* Video Section */}
      <section className="py-20" data-testid="video-section">
        <div className="max-w-7xl mx-auto px-6 md:px-12">
          <div className="max-w-4xl mx-auto">
            <div className="text-center mb-10">
              <h2 className="text-3xl md:text-4xl font-bold text-[#1A1A1A] mb-6">
                Ce que je faisais avant de lancer <span className="text-[#10B981]">0to1</span>
              </h2>
              <p className="text-[#1E3A5F] font-semibold text-lg leading-relaxed max-w-2xl mx-auto">
                En attendant les témoignages de mes partenaires, je vous invite à découvrir mon parcours à travers cette vidéo. Elle vous donnera un aperçu concret de mon expérience et de la valeur ajoutée que je peux apporter à votre croissance commerciale.
              </p>
            </div>
            
            {/* Video Embed */}
            <div className="bg-white rounded-3xl shadow-xl overflow-hidden border border-gray-100">
              <div className="relative w-full" style={{ paddingBottom: '56.25%' }}>
                <iframe
                  title="Ce que je faisais avant de lancer 0to1"
                  src="https://player.vimeo.com/video/1077986504?h=7e62022134"
                  className="absolute top-0 left-0 w-full h-full"
                  frameBorder="0"
                  allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media"
                  allowFullScreen
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Coming Soon Section */}
      <section className="py-24" data-testid="coming-soon-section">
        <div className="max-w-7xl mx-auto px-6 md:px-12">
          <div className="max-w-2xl mx-auto">
            <div className="bg-[#ECFDF5] border border-gray-100 rounded-3xl p-12 md:p-16 text-center">
              <div className="relative z-10">
                {/* Icon */}
                <div className="w-20 h-20 rounded-2xl bg-[#E8F5F3] flex items-center justify-center mx-auto mb-8">
                  <Clock size={40} className="text-[#10B981]" />
                </div>

                {/* Content */}
                <span className="inline-block text-[#10B981] text-sm font-semibold uppercase tracking-wider mb-4 px-4 py-2 bg-[#E8F5F3] rounded-full">
                  À venir
                </span>
                <h2 className="text-3xl md:text-4xl font-bold text-[#1A1A1A] mb-6">
                  Témoignages en cours de préparation
                </h2>
                <p className="text-[#1E3A5F] font-semibold text-lg leading-relaxed mb-10 max-w-md mx-auto">
                  Je travaille actuellement à recueillir les témoignages des entreprises accompagnées. Revenez prochainement pour découvrir leurs retours d'expérience.
                </p>

                {/* CTA */}
                <div className="flex flex-col sm:flex-row gap-4 justify-center">
                  <Link
                    to="/contact"
                    data-testid="testimonials-cta"
                    className="inline-flex items-center justify-center gap-3 bg-[#10B981] text-white font-semibold rounded-full px-8 py-4 hover:bg-[#0D6B5E] transition-all duration-200"
                  >
                    <MessageSquare size={20} />
                    Devenir partenaire
                  </Link>
                  <Link
                    to="/services"
                    className="inline-flex items-center justify-center gap-3 border-2 border-[#10B981] text-[#10B981] font-semibold rounded-full px-8 py-4 hover:bg-[#E8F5F3] transition-all duration-200"
                  >
                    Découvrir mes services
                    <ArrowRight size={18} />
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
